import { css, Theme } from "@emotion/react";
import { theme } from "styles/theme";

export const UserMenuSidebarStyle = {
  self: ({ colors }: Theme) => css`
    min-width: 280px;
    border-radius: 16px;
    background-color: #0a080b80;
    border: 1px solid ${theme.borders.primary};
    box-shadow: 0 4px 12px 0 rgba(107, 123, 168, 0.25);
    height: fit-content;
  `,

  wallet: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 20px;
    border-bottom: 1px solid ${theme.borders.primary};
    background: ${theme.colors.gradient[1]};
    border-radius: 16px 16px 0 0;
  `,

  walletUsername: ({ colors }: Theme) => css`
    color: ${theme.colors.text.buttonActive};
    font-size: 16px;
    font-weight: 700;
  `,

  walletValue: ({ colors }: Theme) => css`
    color: ${theme.colors.text.buttonActive};
    font-size: 20px;
    font-weight: 700;

    .ant-skeleton-title {
      height: 27px !important;
      width: 106.63px !important;
    }
  `,

  list: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  balance: (isLoadingBalance: boolean) => css`
    margin-left: 10px;
    height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${isLoadingBalance ? "default" : "pointer"};
  `,

  menuItem: (active: boolean) => css`
    padding: 12px 20px;
    display: flex;
    align-items: center;
    flex-direction: row;
    background: ${active ? theme.colors.gradient[1] : "transparent"};
    flex: 1;
    cursor: pointer;
    border-radius: ${active ? "8px" : "0"};
    margin: ${active ? "4px 8px" : "0"};
    transition: all 0.3s ease;
    color: ${active ? theme.colors.text.buttonActive : theme.colors.darkGreen};

    svg {
      width: 24px;
      height: 24px;
    }

    /* Line icons (Deposit, Withdraw, Transfer, History) share .history-icon
       class — they use fill="none" + stroke. Keep fill none; force stroke. */
    svg.history-icon,
    svg.history-icon * {
      fill: none !important;
    }
    svg.history-icon {
      color: ${active
        ? theme.colors.text.buttonActive
        : theme.colors.darkGreen} !important;
      stroke: ${active
        ? theme.colors.text.buttonActive
        : theme.colors.darkGreen} !important;
    }
    svg.history-icon * {
      stroke: ${active
        ? theme.colors.text.buttonActive
        : theme.colors.darkGreen} !important;
    }

    /* Filled icons (Profile, BettingRecord, Bell, Mission, Setting): force fill. */
    svg:not(.history-icon),
    svg:not(.history-icon) * {
      fill: ${active
        ? theme.colors.text.buttonActive
        : theme.colors.darkGreen} !important;
    }

    &:hover {
      background: ${theme.colors.gradient[1]};
      color: ${theme.colors.text.buttonActive};
      border-radius: 8px;
      margin: 4px 8px;

      svg.history-icon,
      svg.history-icon * {
        stroke: ${theme.colors.text.buttonActive} !important;
      }
      svg.history-icon {
        color: ${theme.colors.text.buttonActive} !important;
      }
      svg:not(.history-icon),
      svg:not(.history-icon) * {
        fill: ${theme.colors.text.buttonActive} !important;
      }
    }

    .icon-image {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }

    .loading {
      width: 100% !important;
      margin-left: 5px;
      height: 20px !important;
    }
  `,

  menuLabel: css`
    font-size: 14px;
    font-weight: 600;
    margin-left: 12px;
  `,

  buttonContainer: css`
    padding: 16px;
    border-top: 1px solid ${theme.borders.primary};
  `,

  btnLogout: ({ colors }: Theme) => css`
    height: 40px !important;
    background: ${theme.colors.gradient[1]};
    box-shadow: 0 4px 12px 0 rgba(107, 123, 168, 0.25) !important;
    color: ${theme.colors.text.buttonActive};
    font-size: 14px;
    font-weight: 600;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: none;
    width: 100%;

    & .ant-wave {
      color: ${theme.colors.text.buttonActive};
    }

    &:hover,
    &:active {
      background: ${theme.colors.gradient[1]} !important;
      color: ${theme.colors.text.buttonActive} !important;
      transform: translateY(-1px);
      box-shadow: 0 6px 16px 0 rgba(107, 123, 168, 0.35) !important;
    }
  `,
};
